<template>
  <div
    class="table2-container"
    :class="device.isMobile ? 'table2-container-mobile' : ''"
    @click.stop="(e)=> {
      findChapterFrom(e);
      e.stopPropagation();
    }"
  >
    <div class="table2-title" v-html="content.title"></div>
    <el-table class="table-container" :data="tableData" border style="width: 100%" @cell-click="cellClickHandle">
      <el-table-column v-for="(item, index) in headerData" :prop="item.prop" :label="item.label" :key="index" :width="item.width * rem" align="center" :resizable="false">
        <template slot-scope="scope">
          <!-- <textIndex :content="scope.row[item.prop]" :isInTable="true"></textIndex> -->
          <div v-if="item.prop === 'number'">{{ scope.row[item.prop] }}</div>
          <div
            v-else
            :ref="item.prop + scope.row['number']"
            class="table-input"
            contenteditable
            @input="inputHandle(item.prop, scope.row)"
            @blur="inputHandle(item.prop, scope.row)"
          >
            <!-- {{ scope.row[item.prop] }} -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-add" @click.stop="addTable"></div>
  </div>
</template>

<script>
export default {
  name: "workOrdertable2",
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      rem: null,
      headerData: [
        {
          prop: "number",
          label: "序号",
          width: 80,
        },
        {
          prop: "step",
          label: "实施步骤",
          width: 174,
        },
        {
          prop: "problem",
          label: "遇到的问题",
          width: 214,
        },
        {
          prop: "solution",
          label: "解决办法",
        },
      ],
      tableData: [
        {
          number: 1,
          step: '',
          problem: '',
          solution: '',
        }
      ],
    }
  },
  mounted() {
    this.initRem();
  },
  methods: {
    initRem() {
      let width = window.document.documentElement.getBoundingClientRect().width;
      if (!this.device.isMobile) {
        width = 750;
      }else{
        width = width > 750 ? 750 : width;
      }
      this.rem = width / 750; // 将屏幕宽度分为10份， 1份为1rem
    },
    addTable(e) {
      let number = this.tableData.length + 1
      this.tableData.push({
        number,
        step: '',
        problem: '',
        solution: '',
      })
      this.findChapterFrom(e)
    },
    cellClickHandle(row, column, cell, event) {
      let refName = column.property + row.number;
      this.$refs[refName] && this.$refs[refName][0].focus();
    },
    inputHandle(prop, item){
      let refName = prop + item.number;
      let textValue = this.$refs[refName][0].innerText;

      let tableIndex = this.tableData.findIndex(table => table.number == item.number)
      this.$set(this.tableData[tableIndex], prop, textValue);
    },
    submitHandle() {
      return {table2: 22222}
    },
  }
}
</script>

<style lang="scss" scoped>
.table2-container{
  width: 660rem;
  margin-left: 16rem;
  margin-top: 30rem;
  padding-bottom: 30rem;
  position: relative;

  .table2-title{
    text-align: center;
    font-size: 16rem;
    color: #666;
  }

  .table-container{
    .table-input{
      outline: none;
      text-align: left;
    }
  }

  .table-add{
    width: 30rem;
    height: 30rem;
    background: url(~@/assets/images/books/book1/workOrder/table-add.png) center center no-repeat;
    background-size: contain;
    position: absolute;
    bottom: 2rem;
    left: 50%;
    margin-left: -15rem;
    cursor: pointer;
  }

  /deep/.table-container.el-table--border{
    border: 2px solid #333;
    .el-table__cell{
      border-right: 1px solid #A5A0A3
    }
  }
  /deep/.table-container.el-table{
    box-sizing: border-box;
    .el-table__body-wrapper{
      overflow: hidden;
    }
    th.el-table__cell{
      border-bottom: 1px solid #A5A0A3 !important;
      background-color: #DBECFA;
      color: #333;
      font-size: 16rem;
      font-weight: normal;
      .cell{
        padding: 0 10rem;
      }
    }
    td.el-table__cell{
      border-bottom: 1px solid #A5A0A3;
      font-size: 16rem;
      color: #333;
    }
    .cell{
      line-height: 26rem;
    }
    tbody {
      .el-table__row{
        &:last-child{
          .el-table__cell{
            border-bottom: 0;
          }
        }
      }
    }
  }
}
.table2-container-mobile{
  .table2-title{
    font-size: 20rem;
  }
  /deep/.table-container.el-table{
    th.el-table__cell{
      font-size: 26rem;
    }
    td.el-table__cell{
      font-size: 26rem;
    }
    .cell{
      line-height: 32rem;
    }
  }
}
</style>